import { Typography } from '../typography/Typography';

import type { ElementType } from 'react';
import type { TextProps } from '../typography';

export interface DescriptionProps {
  children: string | readonly string[];
  variant?: TextProps['variant'];
  as?: ElementType;
}

export const Description = ({ children, variant, as }: DescriptionProps): JSX.Element => {
  const paragraphs = typeof children === 'string' ? children.split('\n').filter(Boolean) : children;

  return (
    <>
      {paragraphs.map(
        (paragraph, i) =>
          !!paragraph && (
            <Typography as={as} variant={variant} key={i}>
              {paragraph}
            </Typography>
          ),
      )}
    </>
  );
};
